import { QuoteOutputCourse, QuoteOutputProduct } from '../store';
import { ProductPrices } from './product-prices.type';

export interface QuoteBreakdown {
  course?: QuoteOutputCourse;
  accommodation?: QuoteOutputProduct & { description?: string };
  transfer?: { transfers?: QuoteOutputProduct[]; prices?: ProductPrices };
  insurance?: QuoteOutputProduct;
  premiumAccommodation?: QuoteOutputProduct;
  privateLessons?: QuoteOutputProduct;
  unaccompaniedMinorServices?: ProductPrices;
  premiumActivities?: { activities?: QuoteOutputProduct[]; prices?: ProductPrices };
  feesAndSupplements?: QuoteOutputProduct[];
  professionalImmersionExperience?: QuoteOutputProduct;
}
